<template>
    <autocomplete
        :search="search"
        class="autocomplete"
        :placeholder="t('clients_field-placeholder')"
        :aria-label="t('clients_field-aria_label')"
        ref="field"
        @submit="onSubmit"
        :get-result-value="getResultValue"
    >
        <template #result="{ result, props }">
            <li v-bind="props" class="autocomplete-result">
                <template v-if="result.first_name">
                    {{ result.first_name }} {{ result.last_name }} <br />
                    {{ result.whatsapp }}
                </template>
                <template v-else>
                    {{ result.whatsapp }} <br />
                    {{ t('dashboard-searchClient-not_registered') }}
                </template>
            </li>
        </template>
    </autocomplete>
</template>
<script>
import Autocomplete from "@trevoreyre/autocomplete-vue";
import keviApi from "../keviApi";
export default {
    props: {
        value: {
            type: String,
            default: null,
        },
        nameOnly: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Autocomplete,
    },
    mounted() {
        if (this.value) {
            let options = keviApi.getOptions(
                "place/client/" + this.value,
                "GET",
            );
            this.$http(options).then((response) => {
                this.$refs.field.setValue({
                    clients_id: response.body.id,
                    first_name: response.body.first_name,
                    last_name: response.body.last_name,
                    whatsapp: response.body.whatsapp,
                });
            });
        }
    },
    watch: {
        value(newV, oldV) {
            if (newV !== oldV && newV) {
                let options = keviApi.getOptions(
                    "place/client/" + this.value,
                    "GET",
                );
                return this.$http(options).then((response) => {
                    this.$refs.field.setValue({
                        clients_id: response.body.id,
                        first_name: response.body.first_name,
                        last_name: response.body.last_name,
                        whatsapp: response.body.whatsapp,
                    });
                });
            }
            this.$refs.field.setValue(null);
        },
    },
    methods: {
        search(input) {
            return new Promise((resolve) => {
                let options = keviApi.getOptions("place/clients", "GET", {
                    page: 1,
                    search: input,
                    source: "clients-filter",
                });
                this.$http(options).then((response) => {
                    resolve(response.body.data);
                });
            });
        },

        formatName(result) {
            const firstName = (result.first_name || "").trim();
            const lastName = (result.last_name || "").trim();
            return [firstName, lastName].filter(Boolean).join(" ");
        },
        getResultValue(result) {
            if (result.first_name) {
                const name = this.formatName(result);
                if (this.nameOnly) {
                    return name;
                }
                const whatsapp = result.whatsapp ?? "";
                return name + " - " + whatsapp;
            } else {
                return result.whatsapp;
            }
        },

        onSubmit(result) {
            this.$emit("input", result.clients_id);
        },
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>
<style lang="less" scoped>
::v-deep {
    .autocomplete-input {
        display: block;
        width: 100%;
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition:
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
    }
    .autocomplete-result-list {
        position: absolute;
        background: #fff;
        color: #333;
        left: 0;
        width: 100%;
        padding: 0;
        top: 100%;
        margin-top: 0;
        text-align: left;
        border-radius: 4px;
        z-index: 10;
        cursor: default;
        border: 1px solid #ddd;
        li {
            margin: 0;
            list-style: none;
            padding: 5px;
            font-size: 12px;
            &:hover {
                background: #f5f5f5;
            }
        }
    }
}
</style>
